import { UPDATE_SEARCHTDATA_TAIKHOAN_BANK } from "../../../actions/TichHopBank/DanhSachTaiKhoanBank/actionTypes";

const initialState = {
  sSearch:"",
  sMaNganHang : "",
  iPageIndex: 1,
  iPageSize: 25,
  isKhoa: "",
  isDangKyNhanPushBDSD: ""
};
const updateDataSearch = (state, action) => ({
  ...action.payload,
});

export const dataSearchTaiKhoanBank = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_TAIKHOAN_BANK:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchTaiKhoanBank;
